export default "__VITE_ASSET__DUWv1Cqk__"